import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Calendar = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M26.083 6.002c1.066 0.044 1.917 0.922 1.917 1.998v17c0 1.105-0.895 2-2 2h-19c-1.105 0-2-0.895-2-2v-17c0-1.077 0.851-1.955 1.917-1.998v1.061c0 0.794 0.644 1.438 1.437 1.438s1.438-0.644 1.438-1.438v-1.063h5.271v1.063c0 0.794 0.644 1.438 1.438 1.438s1.438-0.644 1.438-1.438v-1.063h5.271v1.063c0 0.794 0.644 1.438 1.438 1.438s1.438-0.644 1.438-1.438v-1.061zM6.917 12v3.492h5.62v-3.492h-5.62zM6.917 16.889v3.492h5.62v-3.492h-5.62zM6.917 21.778v3.492h5.62v-3.492h-5.62zM13.661 12v3.492h5.62v-3.492h-5.62zM13.661 16.889v3.492h5.62v-3.492h-5.62zM13.661 21.778v3.492h5.62v-3.492h-5.62zM20.404 12v3.492h5.62v-3.492h-5.62zM20.404 16.889v3.492h5.62v-3.492h-5.62zM20.404 21.778v3.492h5.62v-3.492h-5.62z" />
  </SvgIcon>
);

export default Calendar;
